var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0148 8.72467C17.0137 8.60905 16.9811 8.4959 16.9207 8.39731C16.8603 8.29873 16.7742 8.2184 16.6717 8.16492L0.872204 0.490868C0.751632 0.427442 0.613931 0.404252 0.479236 0.424687C0.34454 0.445123 0.219915 0.508113 0.123581 0.604447C0.0272467 0.700781 -0.035743 0.825406 -0.0561785 0.960102C-0.0766141 1.0948 -0.0534236 1.2325 0.0100022 1.35307L3.91474 8.72467L-0.0080545 16.0782C-0.0750366 16.2032 -0.0985284 16.3468 -0.0748254 16.4866C-0.0511225 16.6264 0.0184272 16.7543 0.122856 16.8501V16.8501C0.216543 16.9431 0.336731 17.0047 0.466883 17.0265C0.597034 17.0484 0.730752 17.0293 0.849634 16.972L16.6491 9.29797C16.7579 9.24657 16.85 9.16548 16.9146 9.06405C16.9793 8.96262 17.0141 8.84497 17.0148 8.72467V8.72467ZM2.05491 14.9722L5.02522 9.36568H8.24832C8.3325 9.36568 8.41585 9.3491 8.49362 9.31689C8.57139 9.28467 8.64206 9.23746 8.70158 9.17793C8.7611 9.11841 8.80832 9.04775 8.84053 8.96997C8.87275 8.8922 8.88933 8.80885 8.88933 8.72467C8.88933 8.64049 8.87275 8.55714 8.84053 8.47937C8.80832 8.4016 8.7611 8.33093 8.70158 8.27141C8.64206 8.21189 8.57139 8.16467 8.49362 8.13246C8.41585 8.10024 8.3325 8.08366 8.24832 8.08366L5.02522 8.08366L2.05491 2.47709L14.9112 8.72467L2.05491 14.9722Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendicon);
export default __webpack_public_path__ + "static/media/sendicon.50d90575ef0595cef87030934cd7203e.svg";
export { ForwardRef as ReactComponent };